import React, { useEffect } from "react";
import TextField from "@material-ui/core/TextField";
import Style from "../../styles/js/StyleReservations.js";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import Axios from "axios";
import * as Constants from "../../consts/Constants.js";
import { formatDateDDMMYYYYHHMM } from "../../utils/DateUtils";
import { ColorButton } from "../../components/common/CustomButton.js";
import * as ScreenText from "../../consts/ScreenText.js";

export default function ReservationInputsForm({
  state,
  handleChange,
  handleSubmit,
}) {
  const style = Style();

  const [events, setEvents] = React.useState([]);
  const [shifts, setShifts] = React.useState([]);

  const getShiftsByEvent = (eventId, startDate, endDate) => {
    let startDateParam = new Date(startDate).getTime().toString();
    let endDateParam = new Date(endDate).getTime().toString();
    Axios.get(
      Constants.FINAL_URL_RESERVATIONS +
        Constants.URL_EVENTS +
        eventId +
        "/" +
        Constants.URL_SHIFT +
        "/" +
        "?startDate=" +
        startDateParam +
        "&endDate=" +
        endDateParam
    )
      .then((response) => {
        if (response.status === Constants.RESPONSE_OK) {
          let data = response.data;
          setShifts(data);
        }
      })
      .catch((error) => {});
  };

  const getEvents = () => {
    let source = Axios.CancelToken.source();
    Axios.get(Constants.FINAL_URL_RESERVATIONS + Constants.URL_EVENTS, {
      cancelToken: source.token,
    })
      .then((response) => {
        let data = [];
        response.data.forEach((event) => {
          data.push(event);
        });
        setEvents(data);
      })
      .catch(function () {});
    return () => source.cancel();
  };

  const handleLocalChange = (event) => {
    if (event.target.name === "event") {
      getShiftsByEvent(event.target.value, state.startDate, state.endDate);
    } else if (event.target.name === "startDate")
      getShiftsByEvent(state.event, event.target.value, state.endDate);
    else if (event.target.name === "endDate")
      getShiftsByEvent(state.event, state.startDate, event.target.value);
    handleChange(event);
  };

  useEffect(() => {
    getEvents();
  }, []);

  return (
    <div className={style.inputsForm}>
      <div className={style.inputRow}>
        <FormControl className={style.formControl}>
          <InputLabel id="demo-simple-select-label">Evento</InputLabel>
          <Select
            name="event"
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            onChange={handleLocalChange}
            value={state.event}
          >
            <MenuItem key={-1} value={-1}>
              Seleccionar
            </MenuItem>
            {events.map((item) => (
              <MenuItem key={item.id} value={item.id}>
                {item.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
      <div className={style.inputRow}>
        <FormControl className={style.formControl}>
          <TextField
            id="datetime-local"
            label="Fecha de inicio"
            type="datetime-local"
            name="startDate"
            value={state.startDate}
            onChange={handleLocalChange}
            disabled={state.event === -1}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </FormControl>
        <FormControl className={style.formControl}>
          <TextField
            id="datetime-local"
            label="Fecha de fin"
            type="datetime-local"
            name="endDate"
            value={state.endDate}
            onChange={handleLocalChange}
            disabled={state.event === -1}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </FormControl>
      </div>
      <div className={style.inputRow}>
        <FormControl className={style.formControl}>
          <InputLabel id="demo-simple-select-label">Turno</InputLabel>
          <Select
            name="shift"
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            onChange={handleChange}
            disabled={state.event === -1}
            value={state.shift}
          >
            <MenuItem key={-1} value={-1}>
              Seleccionar{" "}
            </MenuItem>
            {shifts.map((item) => (
              <MenuItem key={item.date} value={item.date}>
                {formatDateDDMMYYYYHHMM(item.date).toString()}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
      <div className={style.inputRow}>
        <ColorButton
          disabled={state.shift === -1}
          className={style.actionButton}
          onClick={handleSubmit}
          variant="contained"
        >
          {ScreenText.RESERVATION_SEARCH_BUTTON}
        </ColorButton>
      </div>
    </div>
  );
}
